export default __webpack_public_path__ + "static/esg-reports-61d497e674cc2899fb0534fffc58eaa4.png";